import { shared } from "..";
import { JobManagerContact } from "../../types";

export const convertJobManagerContactResponse = (
    response: shared.JobManagerContactResponse
): JobManagerContact => {
    if (!response) return null;

    const jobManagerContact = new JobManagerContact();
    jobManagerContact.fullName = response.fullName;
    jobManagerContact.email = response.email;
    jobManagerContact.phoneNumber = response.phoneNumber;
    jobManagerContact.profileImageUrl = response.profileImageUrl;
    jobManagerContact.userId = response.userId;
    jobManagerContact.roleName = response.roleName;
    jobManagerContact.initials = response.initials;

    return jobManagerContact;
};
